<template>
    <v-col cols="12" class="MyPlan mt-0 pt-0">
        <v-row
                align="stretch"
                justify="space-around"
                class="pa-4 pt-0"
                style="height: 100%"
        >
            <v-col cols="12" >
                <v-card
                        class="pa-4 elevation-0"
                        tile
                        height="100%"
                >
                    <h2 class="font-weight-medium">Tu suscripción </h2>
                    <v-row>
                        <v-col cols="12" class="d-none d-md-block">
                                <v-stepper alt-labels>
                                    <v-stepper-header class="text-center elevation-0">
                                        <v-stepper-step step="1" complete>Selecciona tus productos</v-stepper-step>

                                        <v-divider></v-divider>

                                        <v-stepper-step step="2">Selecciona tu medio de pago</v-stepper-step>

                                        <v-divider></v-divider>

                                        <v-stepper-step step="3">Datos de facturación</v-stepper-step>

                                        <v-divider></v-divider>

                                        <v-stepper-step step="4">Términos y condiciones</v-stepper-step>

                                        <v-divider></v-divider>

                                        <v-stepper-step step="5">Realiza tu pago</v-stepper-step>
                                        <v-divider></v-divider>

                                        <v-stepper-step step="6">Comprobante de compra</v-stepper-step>
                                    </v-stepper-header>
                                </v-stepper>
                            </v-col>
                            <v-col cols="8">
                                <h4 class="my-4">Selecciona tu plan <small class="caption">Selecciona el plan según tus necesidades</small></h4>
                                <v-row>
                                    <v-col cols="3" class="pa-1">
                                        <v-card height="250px" class="shadow-1 text-center rounded-lg px-1 py-5 card-plan">
                                            <h5 class="grey--text" >Hasta</h5>
                                            <h1 class="blue--text">1MW</h1>
                                            <h5 class="blue--text">Energía</h5>
                                            <v-chip class="py-8 rounded-0 chip-label" dark color="blue" label>
                                                <h1>0 <small>uf/año</small></h1>
                                            </v-chip>
                                            <v-btn class="ma-2" small outlined color="primary">Agregar al Carro</v-btn>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="3" class="pa-1">
                                         <v-card height="250px" class="shadow-1 text-center px-1 py-5 rounded-lg card-plan active" >
                                            <h5 class="grey--text" >Hasta</h5>
                                            <h1 class="orange--text">5MW</h1>
                                            <h5 class="orange--text">Energía</h5>
                                            <v-chip class="py-8 rounded-0 chip-label" dark color="orange" label>
                                                <h1>25 <small>uf/año</small></h1>
                                            </v-chip>
                                            <v-btn class="ma-2" small outlined color="primary">Agregar al Carro</v-btn>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="3" class="pa-1">
                                         <v-card height="250px" class="shadow-1 text-center px-1 rounded-lg py-5 card-plan">
                                            <h5 class="grey--text" >Hasta</h5>
                                            <h1 class="green--text">5MW</h1>
                                            <h5 class="green--text">Energía</h5>
                                            <v-chip class="py-8 rounded-0 chip-label" dark color="green" label>
                                                <h1>25 <small>uf/año</small></h1>
                                            </v-chip>
                                            <v-btn class="ma-2" small outlined color="primary">Agregar al Carro</v-btn>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="3" class="pa-1">
                                         <v-card height="250px" class="shadow-1 text-center px-1 rounded-lg py-5 card-plan" disabled>
                                            <h5 class="grey--text" >Hasta</h5>
                                            <h1 class="orange--text">5MW</h1>
                                            <h5 class="orange--text">Energía</h5>
                                            <v-chip class="py-8 rounded-0 chip-label" dark color="orange" label>
                                                <h1>100 <small>uf/año</small></h1>
                                            </v-chip>
                                            <v-btn class="ma-2" small outlined color="primary">Agregar al Carro</v-btn>
                                        </v-card>
                                    </v-col>
                                </v-row>
                                <h4 class="my-4">Servicios complementarios <small class="caption">Servicios, descuentos y promociones para optimizar tu plan</small></h4>
                                <v-row>
                                    <v-col cols="3" class="pa-1">
                                        <v-card height="250px" class="shadow-1 text-center rounded-lg px-1 py-5 card-plan active" >
                                            <h1 class="blue--text">25%</h1>
                                            <h5 class="blue--text">descuento</h5>
                                            <h6 class="font-weight-light red--text">Por pago adelantado</h6>
                                            <h4>PAGO DE ENVÍO <br> DE SOLICITUDES</h4>
                                            <v-btn class="ma-2" small outlined color="primary">Agregar al Carro</v-btn>
                                        </v-card>
                                    </v-col>
                                    <v-col cols="3" class="pa-1">
                                         <v-card height="250px" class="shadow-1 text-center rounded-lg px-1 py-5 card-plan" >
                                            <h1 class="blue--text">25%</h1>
                                            <h5 class="blue--text">descuento</h5>
                                             <h6 class="font-weight-light red--text">Por pago adelantado</h6>
                                             <h4>PAGO DE ENVÍO <br> DE SOLICITUDES</h4>
                                            <v-btn class="ma-2" small outlined color="primary">Agregar al Carro</v-btn>
                                        </v-card>
                                    </v-col>
                                </v-row>
                            </v-col>
                            <v-col cols="4">
                                <h4 class="mb-4">Selecciona tu PLan</h4>
                                <div class="my-4 d-flex">
                                    <v-icon color="green"> mdi-check </v-icon>
                                    <span class="ml-3">Despliegue de todas las ofertas disponibles</span>
                                </div>
                                <div class="my-4 d-flex">
                                    <v-icon color="green"> mdi-check </v-icon>
                                    <span class="ml-3">Datos de contacto de los ejecutivos de los administradores</span>
                                </div>
                                <div class="my-4 d-flex">
                                    <v-icon color="green"> mdi-check </v-icon>
                                    <span class="ml-3">Datos estadisticos de los suministros del CEN</span>
                                </div>
                                <div class="my-4 d-flex">
                                    <v-icon color="green"> mdi-check </v-icon>
                                    <span class="ml-3">Datos estadisticos de los suministradores surgidos en la aplicación</span>
                                </div>
                                <div class="my-4 d-flex">
                                    <v-icon color="green"> mdi-check </v-icon>
                                    <span class="ml-3">Envío de solicitud al suministrador</span>
                                </div>
                                <v-btn color="green"
                                       raised
                                       dark
                                       to="/system/payment/payment"
                                       class="pa-6">ir al carro</v-btn>
                            </v-col>
                        </v-row>

                </v-card>
            </v-col>
        </v-row>
    </v-col>
</template>

<script>
    export default {
        name: 'MyPlan',
         created: function () {
            //this.$emit('SetcolorMenu', '#FE9A00');
        }
    }
</script>
